import firebase from 'firebase/app'
import { AxiosClient } from '@/client'

export default class AuthApi {
  _api: AxiosClient
  constructor() {
    this._api = new AxiosClient()
  }

  getCurrentUser() {
    return new Promise((resolve, reject) => {
      const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
        unsubscribe()
        resolve(user)
      }, reject)
    })
  }

  async getConfig() {
    let user: any = await this.getCurrentUser()
    let token = await user.getIdToken()
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  }

  async getUserInfo(userId: any) {
    const apiURL = `/v1/user/${userId}`

    try {
      const response = await this._api.get(apiURL)
      return response.data
    } catch (err) {
      console.log('Error retrieving user information.', err)
      return null
    }
  }

  async getGroups(userData: any) {
    let newGroups: Array<string> = []
    const inGroups = userData.inGroups
    inGroups.forEach((group: any) => {
      newGroups.push(group.name.toLowerCase())
    })

    const groups = [...new Set(newGroups)]
    return groups
  }
}
